import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import {
  withConnect,
  withReducer,
  getValueSelector,
  UPDATE_VALUE
} from 'containers/Form/Input/index'
import HexInput from 'components/form/hexInput/index'
import withHexValidation from 'containers/Form/Util/Validation/hex'
import withValueObserver from 'containers/Form/Util/Validation/valueSaga'

export { default as HexInput } from 'components/form/hexInput/index'
export {
  withConnect,
  withReducer
} from 'containers/Form/Input/index'

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
  withHexValidation(path, id, getValueSelector(path, id)),
  withValueObserver(path, id, UPDATE_VALUE)
)(HexInput))
